import terminateTemplate from './terminate.html';

angular.module('org.saga.terminate', [
   'org.saga.service',
])

   .factory('TerminateDialog', ['$mdDialog', '$log', function($mdDialog, $log) {

      return {
         show: function(callback) {
            function DialogController($scope, $log, $mdDialog, $translate) {
               $scope.cancel = function() {
                  $mdDialog.cancel();
               };

               $scope.ok = function() {
                  $mdDialog.hide();
               };
            }

            $mdDialog.show({
               controller: ['$scope', '$log', '$mdDialog', '$translate', DialogController],
               template: terminateTemplate,
               parent: angular.element(document.body),
               clickOutsideToClose: true
            })
               .then(function() {
                  callback();
               }, function() {
                  // dialog is closed
               });

         }
      };
   }]);
